import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface AuthState {
  token: string | null;
  user: any | null;
  isLoggedIn: boolean;
  isLogOut: boolean;
  isLoading: boolean;
  isAuthError: boolean;
  error: any | null;
}

const initialState: AuthState = {
  token: null,
  user: null,
  isLoggedIn: false,
  isLoading: false,
  isAuthError: false,
  isLogOut: false,
  error: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login(state, action: PayloadAction<string>) {
      state.token = action.payload;
      state.isLoggedIn = true;
      state.isLogOut = false;
    },
    logout(state) {
      state.token = null;
      state.isLoggedIn = false;
      state.isLogOut = true;
    },
    authFailed(state, action: PayloadAction<any>) {
      state.token = null;
      state.isLoggedIn = false;
      state.isAuthError = true;
      state.error = action?.payload?.error || 'Authentication error.'
    },
    signupRequest: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    signupSuccess: (state, action: PayloadAction<any>) => {
      state.isLoading = false;
      state.user = action.payload;
      state.isLoggedIn = false;
      state.error = null;
    },
    signupFailure: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    loginRequest: (state) => {
      state.isLoading = true;
      state.error = null;
    },
    loginSuccess: (state, action: PayloadAction<any>) => {
      state.isLoading = false;
      state.user = action.payload;
      state.isLoggedIn = true;
      state.isAuthError = false;
      state.error = null;
    },
    loginFailure: (state, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const { login, logout, authFailed } = authSlice.actions;

export const { signupRequest, signupSuccess, signupFailure, loginRequest, loginSuccess, loginFailure } = authSlice.actions;
export default authSlice.reducer;

